function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="32" height="32" viewBox="0 0 32 32" {...props}><g fill="#0275D8"><path d="M9 32h23V9H9zM0 9h9V0H0z" /></g></svg>;
});


// WEBPACK FOOTER //
// ./media/svg/logo.svg